// extracted by mini-css-extract-plugin
export default {"total-campaigns":"Active_total-campaigns__zjwuu","button":"Active_button__F6cAT","switch":"Active_switch__EX3NM","slider":"Active_slider__5WjBQ","round":"Active_round__2wLF+"};